const PLATFORM_SESSION_KEY = 'nutritrack-app-platform';

export const getAppPlatform = () => {
  if (typeof window === 'undefined') return '';

  const requestedPlatform = new URLSearchParams(window.location.search).get('app');
  if (requestedPlatform === 'ios') {
    window.sessionStorage.setItem(PLATFORM_SESSION_KEY, 'ios');
  }

  return window.sessionStorage.getItem(PLATFORM_SESSION_KEY) || '';
};

export const isIosApp = () => getAppPlatform() === 'ios';
